export default function formatDateToYYYYMMDD(date: Date) {
  const year = date.getFullYear().toString();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');

  return year + month + day;
}
